import tw from "src/utils/tw";

export default function Notice(props) {
  return (
    <div
      className={tw(
        "text-xs",
        "text-organization",
        "uppercase",
        "bg-paleAction",
        "rounded",
        "inline-block",
        "px-2",
        "py-1",
        "leading-none",
        "border",
        "border-organization",
        props.className
      )}
    >
      <i aria-hidden className="far fa-triangle-exclamation" /> {props.children}
    </div>
  );
}
